module.exports = __webpack_public_path__ + "img/中海地产.9c7e77b5.png";